export default __webpack_public_path__ + "81b87369df0efd57a09ff8d1de3830ac.svg";